import React, { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { getContrastColor } from '../../utils/colorUtils';
import {
  FooterWrapper, FooterGrid, Brand, BrandName, BrandDesc, BrandEmail,
  SocialRow, SocialBtn, FooterCol, ColTitle, LinkList, LinkItem, FooterLink,
  FooterAnchor, FooterBottom, LegalRow,
} from './Footer.styles';

/* ── Iconos inline SVG (sin librería, idénticos al diseño de referencia) ── */
const IcoInfo     = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>;
const IcoZap      = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>;
const IcoMail     = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>;
const IcoFaq      = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><circle cx="12" cy="12" r="10"/><path strokeLinecap="round" strokeLinejoin="round" d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"/></svg>;
const IcoShield   = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>;
const IcoWarn     = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>;
const IcoDoc      = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>;
const IcoLock     = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>;
const IcoUpload   = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"/></svg>;
const IcoBag      = () => <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg>;

/* ── Redes sociales ── */
const IcoIG = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={16} height={16}><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/></svg>;
const IcoFB = () => <svg viewBox="0 0 24 24" fill="currentColor" width={16} height={16}><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>;
const IcoX  = () => <svg viewBox="0 0 24 24" fill="currentColor" width={16} height={16}><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>;
const IcoTK = () => <svg viewBox="0 0 24 24" fill="currentColor" width={16} height={16}><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.75a8.16 8.16 0 004.77 1.52V6.82a4.85 4.85 0 01-1-.13z"/></svg>;

export default function Footer({ onDenunciar }) {
  const { theme } = useContext(ThemeContext);
  const bg    = theme.background || '#000';
  const acc   = theme.accent     || '#667eea';
  const color = getContrastColor(bg);

  return (
    <FooterWrapper bg={bg} accent={acc} color={color}>
      <FooterGrid accent={acc}>

        {/* ── Marca ── */}
        <Brand>
          <BrandName accent={acc} color={color}>
            <span>tu</span>trastero.com
          </BrandName>
          <BrandDesc color={color}>
            El marketplace de segunda mano entre particulares. Vende, compra o haz trueque con lo que ya no necesitas.
          </BrandDesc>
          <BrandEmail href="mailto:info@trasteroweb.es" accent={acc} bg={bg}>
            <IcoMail />
            contacto@trasteroweb.es
          </BrandEmail>
          <SocialRow>
            <SocialBtn href="https://instagram.com/trasteroweb" accent={acc} color={color} title="Instagram" target="_blank" rel="noopener"><IcoIG /></SocialBtn>
            <SocialBtn href="https://facebook.com/trasteroweb"  accent={acc} color={color} title="Facebook"  target="_blank" rel="noopener"><IcoFB /></SocialBtn>
            <SocialBtn href="https://twitter.com/trasteroweb"   accent={acc} color={color} title="X/Twitter" target="_blank" rel="noopener"><IcoX  /></SocialBtn>
            <SocialBtn href="https://tiktok.com/@trasteroweb"   accent={acc} color={color} title="TikTok"    target="_blank" rel="noopener"><IcoTK /></SocialBtn>
          </SocialRow>
        </Brand>

        {/* ── Empresa ── */}
        <FooterCol>
          <ColTitle color={color}>Empresa</ColTitle>
          <LinkList>
            <LinkItem><FooterLink to="/about"         color={color} accent={acc}><IcoInfo   />Sobre nosotros</FooterLink></LinkItem>
            <LinkItem><FooterLink to="/como-funciona" color={color} accent={acc}><IcoZap    />Cómo funciona</FooterLink></LinkItem>
            <LinkItem><FooterLink to="/contact"       color={color} accent={acc}><IcoMail   />Contacto</FooterLink></LinkItem>
          </LinkList>
        </FooterCol>

        {/* ── Ayuda ── */}
        <FooterCol>
          <ColTitle color={color}>Ayuda</ColTitle>
          <LinkList>
            <LinkItem><FooterLink to="/faq"      color={color} accent={acc}><IcoFaq    />Preguntas frecuentes</FooterLink></LinkItem>
            <LinkItem><FooterLink to="/consejos" color={color} accent={acc}><IcoShield />Consejos de seguridad</FooterLink></LinkItem>
            <LinkItem><FooterAnchor as="button" onClick={onDenunciar} color={color} accent={acc} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit' }}><IcoWarn />Reportar contenido</FooterAnchor></LinkItem>
          </LinkList>
        </FooterCol>

        {/* ── Legal ── */}
        <FooterCol>
          <ColTitle color={color}>Legal</ColTitle>
          <LinkList>
            <LinkItem><FooterLink to="/legal/terminos"               color={color} accent={acc}><IcoDoc    />Términos y condiciones</FooterLink></LinkItem>
            <LinkItem><FooterLink to="/legal/privacidad"             color={color} accent={acc}><IcoLock   />Política de privacidad</FooterLink></LinkItem>
            <LinkItem><FooterLink to="/legal/condiciones-publicador" color={color} accent={acc}><IcoUpload />Condiciones publicador</FooterLink></LinkItem>
            <LinkItem><FooterLink to="/legal/condiciones-comprador"  color={color} accent={acc}><IcoBag    />Condiciones comprador</FooterLink></LinkItem>
          </LinkList>
        </FooterCol>

      </FooterGrid>

      {/* ── Barra inferior ── */}
      <FooterBottom accent={acc} color={color}>
        <p>© {new Date().getFullYear()} trasteroweb.es · Todos los derechos reservados</p>
        <LegalRow>
          <FooterAnchor href="/legal/terminos" color={color} $accent={acc} small>Términos</FooterAnchor>
          <FooterAnchor href="/legal/privacidad" color={color} $accent={acc} small>Privacidad</FooterAnchor>
        </LegalRow>
      </FooterBottom>
    </FooterWrapper>
  );
}
